module.exports = __webpack_public_path__ + "static/img/image16.12a77f43.png";